<!-- src\app\page\signup-page\signup-page.component.html -->
<div class="container">
  <div class="content-wrapper">
    <img class="logo" src="/assets/images/transend-logo-title.png">
    <div class="title">Sign Up</div>

    @if (errorMessage) {
      <div class="error-wrapper">
        <span class="error-message">{{ errorMessage }}</span>
        <div class="actions">
          <button mat-flat-button color="accent" routerLink="/">Return to Login</button>
        </div>
      </div>
    }

    @if (isLoading && !errorMessage) {
      <div class="loading-wrapper">
        <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      </div>
    }

    @if (!isLoading && !errorMessage) {
      <div class="form-wrapper">
        <form [formGroup]="signupForm" class="signup-form">
          <!-- Email Field -->
          <div class="form-field">
            <label class="field-label" for="email-input">Email</label>
            <mat-form-field appearance="fill" hideRequiredMarker>
              <input matInput formControlName="email" type="email" readonly class="form-input"
                id="email-input" />
                @if (signupForm.get('email')?.errors?.['required']) {
                  <mat-error>Email is required</mat-error>
                }
                @if (signupForm.get('email')?.errors?.['email']) {
                  <mat-error>Invalid email</mat-error>
                }
              </mat-form-field>
            </div>
            <!-- Password Field -->
            <div class="form-field">
              <label class="field-label" for="password-input">Password</label>
              <mat-form-field appearance="fill" hideRequiredMarker>
                <input matInput formControlName="password" type="password" class="form-input"
                  id="password-input" appPasswordViewer #passwordViewer="passwordViewer" />
                  <app-password-toggle-button matSuffix [passwordViewer]="passwordViewer"></app-password-toggle-button>
                </mat-form-field>
                @if (signupForm.get('password')?.touched && signupForm.get('password')?.invalid) {
                  <mat-error class="mat-errors"
                    >
                    @if (signupForm.get('password')?.hasError('required')) {
                      <div>
                        Password is required.
                      </div>
                    }
                    @if (signupForm.get('password')?.hasError('minlength')) {
                      <div>
                        Password must be at least 12 characters long.
                      </div>
                    }
                    @if (signupForm.get('password')?.hasError('maxlength')) {
                      <div>
                        Password must not exceed 128 characters.
                      </div>
                    }
                    @if (signupForm.get('password')?.hasError('uppercase')) {
                      <div>
                        Password must contain at least one uppercase letter.
                      </div>
                    }
                    @if (signupForm.get('password')?.hasError('lowercase')) {
                      <div>
                        Password must contain at least one lowercase letter.
                      </div>
                    }
                    @if (signupForm.get('password')?.hasError('digit')) {
                      <div>
                        Password must contain at least one digit.
                      </div>
                    }
                    @if (signupForm.get('password')?.hasError('special')) {
                      <div>
                        Password must contain at least one special character.
                      </div>
                    }
                    @if (signupForm.get('password')?.hasError('identical')) {
                      <div>
                        Password cannot have more than 2 identical characters in a row.
                      </div>
                    }
                  </mat-error>
                }
              </div>
              <!-- Confirm Password Field -->
              <div class="form-field">
                <label class="field-label" for="confirmPassword-input">Confirm Password</label>
                <mat-form-field appearance="fill" hideRequiredMarker>
                  <input matInput formControlName="confirmPassword" type="password" class="form-input"
                    id="confirmPassword-input" />
                    @if (signupForm.get('confirmPassword')?.errors?.['required']) {
                      <mat-error>Confirm Password is
                      required</mat-error>
                    }
                    @if (signupForm.get('confirmPassword')?.errors?.['passwordMismatch']) {
                      <mat-error>Passwords do
                        not
                      match</mat-error>
                    }
                  </mat-form-field>
                </div>
              </form>
              <div class="form-actions" mat-dialog-actions>
                <button mat-flat-button color="accent" [disabled]="signupForm.invalid || isSubmitting"
                  (click)="signup()">
                  @if (!isSubmitting) {
                    <span>Sign Up</span>
                  }
                  @if (isSubmitting) {
                    <mat-progress-spinner diameter="20"
                    mode="indeterminate"></mat-progress-spinner>
                  }
                </button>
              </div>
            </div>
          }

          @if (!isLoading && !errorMessage) {
            <div class="helper">
              Already have an account? <a routerLink="/login">Sign in here</a>
            </div>
          }
        </div>
      </div>